import { useUserRoles } from '@anytag/auth';
import { AIAssistantState, useInfluencerSearchPathnames, useParamsSearch } from '@anytag/shared-hooks';

export const useAiSidebar = () => {
  const { aiAssistantState, setAiAssistantState } = useParamsSearch();
  const { isSupportedChatAIPaths } = useInfluencerSearchPathnames();
  const { isAdminStaff } = useUserRoles();

  // https://bitbucket.org/adasiaholdings/casting_asia_django/pull-requests/5649/chat-ai-enabled-only-for-admin?link_source=email
  // https://adasiaholdings.atlassian.net/browse/AT-6248
  const isDisabledAiAssistant = !isSupportedChatAIPaths || !isAdminStaff;
  const sidebarState: AIAssistantState = isDisabledAiAssistant
    ? { isAiSidebarOpen: false, isChatHistoryOpen: false, threadId: null, isMobile: false, isMobileOpen: false }
    : aiAssistantState ?? {
        isAiSidebarOpen: false,
        isChatHistoryOpen: false,
        threadId: null,
        isMobile: false,
        isMobileOpen: false
      };

  return { isDisabledAiAssistant, setAiAssistantState, ...sidebarState };
};
